import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "activity-assignment" }
const _hoisted_2 = ["onUpdate:modelValue", "disabled"]
const _hoisted_3 = ["onUpdate:modelValue", "disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "buttons" }

import { DefinitionItem } from "@/services/entities/DefinitionItem";
import { reactive } from "vue";
import { getKey } from "@/common/util";
import DxButton from 'devextreme-vue/button';
import { showToastError } from "@/toastification";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityAssignment',
  props: {
    definitions: { Type: [] as DefinitionItem[], default: [] as DefinitionItem[] },
},
  emits: ['save', 'delete', 'edit'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;
const state = reactive({
    canSave: false
});

function addDefinition() {
    state.canSave = true;
    props.definitions.push({ editable: true });
}

function saveDefinitions() {
    // Check if there are any lines without ActivityNumberId and if there are any duplicates
    if (props.definitions.some(a => !a.activityNumber) || props.definitions.some(a => props.definitions.filter(b => b.activityNumber == a.activityNumber).length > 1)) {
        showToastError("Please input unique activity number for all activities and remove empty ones.");
        return;
    }    
    emit('save', props.definitions)
    state.canSave = false;
}

function saveEdit(item: DefinitionItem, index: number) {
    item.editable = !item.editable;
    emit('edit', item)
}

function updateDefinition(item: DefinitionItem, index: number) {
    item.editable = !item.editable;
}

function deleteDefinition(item: DefinitionItem, index: number) {
    if (item.id) {
        emit('delete', item.id)
    }
    else {
        props.definitions.splice(index, 1);
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("label", null, "Activity number")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", null, "Description")
        ])
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.definitions, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: _unref(getKey)('ac', index)
        }, [
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createElementBlock("input", {
              key: _unref(getKey)('an', index),
              "onUpdate:modelValue": ($event: any) => ((item.activityNumber) = $event),
              disabled: !item.editable,
              type: "string",
              class: _normalizeClass({ 'wrong-activity-number': props.definitions.filter(a => a.activityNumber == item.activityNumber).length > 1 })
            }, null, 10, _hoisted_2)), [
              [_vModelText, item.activityNumber]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createElementBlock("input", {
              key: _unref(getKey)('ad', index),
              "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
              disabled: !item.editable,
              type: "string"
            }, null, 8, _hoisted_3)), [
              [_vModelText, item.description]
            ])
          ]),
          _createVNode(_unref(DxButton), {
            icon: "trash",
            onClick: ($event: any) => (deleteDefinition(item, index))
          }, null, 8, ["onClick"]),
          (item.id && !state.canSave)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (!item.editable)
                  ? (_openBlock(), _createBlock(_unref(DxButton), {
                      key: 0,
                      icon: "edit",
                      onClick: ($event: any) => (updateDefinition(item, index))
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_unref(DxButton), {
                      key: 1,
                      icon: "save",
                      onClick: ($event: any) => (saveEdit(item, index))
                    }, null, 8, ["onClick"]))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: addDefinition,
        class: _normalizeClass({ accent: !state.canSave })
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("b", null, "+", -1),
        _createTextVNode("Add activity", -1)
      ]))], 2),
      (state.canSave)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "accent",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (saveDefinitions()))
          }, "Save"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})